// This file was generated using `pay js:run gql-v1 --type=fragment --name=LegalEntityCompanyVerification --dir=path/to/dir`.
// To generate yours, do not copy and paste; use the command above instead. Do not delete this comment.

/* eslint-disable @stripe-internal/data-v1/camel-case-alias */

import {gql} from '@sail/data';

import type {GraphQlDocument, GraphQlFragmentUnion} from '@sail/data';
import type {Exact} from '@stripe-internal/data-v1/schema/types';
import type {V1PermissionToken} from '@stripe-internal/data-v1/types';
import {legalEntityCompanyVerificationDocumentFragment} from './legalEntityCompanyVerificationDocumentFragment';

import type {LegalEntityCompanyVerificationDocumentFragmentData} from './legalEntityCompanyVerificationDocumentFragment';

const doc = gql`
  fragment LegalEntityCompanyVerificationFragment on OpenapiLegalEntityCompanyVerification {
    details
    details_code
    document {
      ...LegalEntityCompanyVerificationDocumentFragment
    }
    status
  }

  ${legalEntityCompanyVerificationDocumentFragment}
`;

export const legalEntityCompanyVerificationFragment: LegalEntityCompanyVerificationFragmentDocument =
  doc;

// THIS IS AUTOGENERATED CODE, DO NOT EDIT AS YOUR CHANGES WILL BE BLOWN AWAY
// Regenerate it using eslint in fix mode.

export type LegalEntityCompanyVerificationFragmentData = {
  readonly __typename: 'OpenapiLegalEntityCompanyVerification';
  readonly details: string | null;
  readonly details_code: string | null;
  readonly status: string | null;
  readonly document: GraphQlFragmentUnion<
    {readonly __typename: 'OpenapiLegalEntityCompanyVerificationDocument'},
    [LegalEntityCompanyVerificationDocumentFragmentData]
  > | null;
};

export type LegalEntityCompanyVerificationFragmentVariables = Exact<{
  [key: string]: never;
}>;

const legalEntityCompanyVerificationFragmentPermissions = {
  ...legalEntityCompanyVerificationDocumentFragment.permissions,
} as const;

doc.permissions = legalEntityCompanyVerificationFragmentPermissions;

export type LegalEntityCompanyVerificationFragmentPermissions =
  V1PermissionToken<typeof legalEntityCompanyVerificationFragmentPermissions>;

export type LegalEntityCompanyVerificationFragmentDocument = GraphQlDocument<
  LegalEntityCompanyVerificationFragmentData,
  LegalEntityCompanyVerificationFragmentVariables,
  LegalEntityCompanyVerificationFragmentPermissions
>;
